import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen font-roboto bg-slate-50" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "flex-1 overflow-x-hidden overflow-y-auto bg-slate-50" }

import Sidebar from "./components/AppSidebar.vue";
import Header from "./components/AppHeader.vue";
// import Footer from "./components/AppFooter.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}
}

})